import { render, staticRenderFns } from "./receipt-detail-reduction.vue?vue&type=template&id=1952916a"
import script from "./receipt-detail-reduction.vue?vue&type=script&lang=js"
export * from "./receipt-detail-reduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports